import * as React from "react";
const SVGComponent = (props) => (
    <svg
        width={88}
        height={56}
        viewBox="0 0 88 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_0_91)">
            <rect
                x={3.5051}
                y={13.8579}
                width={40}
                height={40}
                rx={10}
                transform="rotate(-15 3.5051 13.8579)"
                fill="url(#paint0_linear_0_91)"
            />
            <g clipPath="url(#clip1_0_91)">
                <path
                    d="M26.0784 15.3202L25.2323 16.5812C25.1137 16.7583 24.8857 16.8194 24.6944 16.7253L23.3278 16.0524C23.2184 15.9983 23.0888 15.9926 22.9778 16.039C22.2989 16.321 21.6256 16.6682 20.9645 17.0789C17.4745 19.2485 15.2677 23.0548 15.1144 27.1758C14.8344 34.8437 20.5854 40.395 27.1836 40.8291C28.5431 40.9176 29.9399 40.7912 31.3279 40.4193C32.7159 40.0474 33.9887 39.4584 35.1218 38.702C39.5811 35.7222 41.8728 30.0987 40.4029 24.6132C38.7156 18.3162 32.6425 14.343 26.3742 15.1313C26.2527 15.1472 26.1427 15.2148 26.0734 15.3192L26.0784 15.3202ZM18.1567 31.7824L18.1583 31.7796L21.9768 30.7564C22.1773 30.8671 22.2941 30.9311 22.4924 31.0424C23.3439 33.6622 24.4823 35.8833 25.7498 37.5146C25.9997 37.8361 25.7042 38.2918 25.3115 38.1897C22.1251 37.3395 19.406 35.0105 18.1528 31.7858L18.1567 31.7824ZM30.8032 38.16C30.7772 38.1693 30.7529 38.1759 30.7285 38.1824C30.7042 38.1889 30.6798 38.1954 30.6527 38.2003C29.2128 38.467 26.4752 35.7235 24.7361 30.4817C24.6597 30.2496 24.7942 29.9991 25.0289 29.9362L31.5415 28.1912C31.7761 28.1283 32.0179 28.278 32.0678 28.5172C33.1826 33.9262 32.1813 37.6716 30.8032 38.16ZM35.4213 35.4808C35.135 35.7672 34.6507 35.518 34.7041 35.1153C34.9993 32.9676 34.8455 30.3301 34.1991 27.4838C34.1985 27.4816 34.2007 27.481 34.2007 27.481L33.7103 25.651C33.6496 25.4242 33.4164 25.2889 33.1906 25.3494L18.0248 29.4131C17.7702 29.4813 17.5201 29.3005 17.492 29.0363C17.1488 25.7895 18.3301 22.6274 20.5519 20.4091C20.8404 20.1221 21.3231 20.3741 21.2681 20.7797C21.0629 22.2717 21.0754 24.0009 21.3169 25.8761C21.3492 26.1296 21.603 26.2975 21.8487 26.2317L23.2677 25.8515C23.4713 25.7969 23.6029 25.5972 23.5775 25.3872C23.0536 21.0591 23.9676 18.1569 25.17 17.7299L25.3183 17.6902C26.5731 17.4588 28.818 19.5145 30.5261 23.5253C30.6091 23.7199 30.8207 23.8277 31.0266 23.7725L32.4433 23.3929C32.689 23.327 32.8254 23.0569 32.7261 22.819C32.0026 21.0753 31.1467 19.5721 30.2246 18.3798C29.9747 18.0583 30.2684 17.5959 30.6595 17.7008C33.8381 18.5483 36.5498 20.8674 37.8072 24.0814C37.8119 24.0992 37.8189 24.1164 37.8237 24.1342L38.4106 26.3244C38.4153 26.3422 38.4201 26.36 38.4226 26.3783C38.9407 29.7905 37.7497 33.1553 35.4207 35.4785L35.4213 35.4808Z"
                    fill="url(#paint1_linear_0_91)"
                />
            </g>
        </g>
        <path
            d="M41.7168 18.9599C43.1663 13.5502 43.891 10.8454 45.4975 9.06124C46.9105 7.49188 48.7842 6.41014 50.8498 5.97107C53.1981 5.47192 55.903 6.19668 61.3127 7.64621L69.0401 9.71676C74.4498 11.1663 77.1546 11.891 78.9388 13.4975C80.5081 14.9105 81.5899 16.7842 82.0289 18.8498C82.5281 21.1981 81.8033 23.903 80.3538 29.3127L78.2832 37.0401C76.8337 42.4498 76.109 45.1546 74.5025 46.9388C73.0895 48.5081 71.2158 49.5899 69.1502 50.0289C66.8019 50.5281 64.097 49.8033 58.6873 48.3538L50.9599 46.2832C45.5502 44.8337 42.8454 44.109 41.0612 42.5025C39.4919 41.0895 38.4101 39.2158 37.9711 37.1502C37.4719 34.8019 38.1967 32.097 39.6462 26.6873L41.7168 18.9599Z"
            fill="white"
        />
        <path
            d="M49.7065 33.0303L50.0715 31.6684L48.5632 31.1465L51.8947 18.7129L72.6166 21.2516L68.1431 37.9469L56.0768 33.7719L52.2535 34.7723L52.8186 32.6634L51.4201 32.171L50.1958 36.7402L55.9856 35.2544L69.0931 39.8495L74.3965 20.0569L50.9326 17.2072L46.9536 32.0572L49.7065 33.0303Z"
            fill="url(#paint2_linear_0_91)"
        />
        <path
            d="M55.4437 27.7868C56.0746 27.9558 56.7231 27.5814 56.8921 26.9506C57.0612 26.3197 56.6868 25.6712 56.0559 25.5022C55.425 25.3331 54.7766 25.7075 54.6075 26.3384C54.4385 26.9693 54.8129 27.6177 55.4437 27.7868Z"
            fill="url(#paint3_linear_0_91)"
        />
        <path
            d="M59.8812 28.9758C60.512 29.1448 61.1605 28.7704 61.3296 28.1396C61.4986 27.5087 61.1242 26.8602 60.4933 26.6912C59.8625 26.5221 59.214 26.8965 59.0449 27.5274C58.8759 28.1583 59.2503 28.8067 59.8812 28.9758Z"
            fill="url(#paint4_linear_0_91)"
        />
        <path
            d="M64.3186 30.1648C64.9495 30.3338 65.598 29.9594 65.767 29.3286C65.936 28.6977 65.5617 28.0492 64.9308 27.8802C64.2999 27.7111 63.6514 28.0855 63.4824 28.7164C63.3133 29.3473 63.6877 29.9957 64.3186 30.1648Z"
            fill="url(#paint5_linear_0_91)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_0_91"
                x1={23.5051}
                y1={13.8579}
                x2={23.5051}
                y2={53.8579}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#29282C" />
                <stop offset={1} stopColor="#100F11" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_0_91"
                x1={10.6937}
                y1={13.857}
                x2={35.8059}
                y2={35.4542}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="white" />
                <stop offset={1} stopColor="white" stopOpacity={0.65} />
            </linearGradient>
            <linearGradient
                id="paint2_linear_0_91"
                x1={50.9561}
                y1={17.1194}
                x2={69.1209}
                y2={39.8334}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00AEEF" />
                <stop offset={1} stopColor="#0097DA" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_0_91"
                x1={51.0028}
                y1={17.2967}
                x2={67.9492}
                y2={39.6372}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01AEEF" />
                <stop offset={1} stopColor="#019BDE" />
            </linearGradient>
            <linearGradient
                id="paint4_linear_0_91"
                x1={55.4402}
                y1={18.4857}
                x2={72.3866}
                y2={40.8262}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01AEEF" />
                <stop offset={1} stopColor="#019BDE" />
            </linearGradient>
            <linearGradient
                id="paint5_linear_0_91"
                x1={59.8777}
                y1={19.6747}
                x2={76.824}
                y2={42.0152}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#01AEEF" />
                <stop offset={1} stopColor="#019BDE" />
            </linearGradient>
            <clipPath id="clip0_0_91">
                <rect
                    x={3.5051}
                    y={13.8579}
                    width={40}
                    height={40}
                    rx={10}
                    transform="rotate(-15 3.5051 13.8579)"
                    fill="white"
                />
            </clipPath>
            <clipPath id="clip1_0_91">
                <rect
                    width={30}
                    height={30}
                    fill="white"
                    transform="translate(9.62913 17.3935) rotate(-15)"
                />
            </clipPath>
        </defs>
    </svg>
);
export default SVGComponent;
